module.exports = __webpack_public_path__ + "media/images/step1-16fbc8574c0e94f5e90faabd29e1f5a0.png";